import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/macro';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ensureURLProtocol, getMediaType } from '../../utils';
import Icons from '../Icons';
import BragifyAvatar from '../../boardOne/BragifyAvatar';
import styles from '../../boardOne/BragifyEmbed.module.css';
import ModalShareButtons from './ModalShareButtons';
import { AnalyticsEvents, AnalyticsScores, networks } from '../../consts';
import Caption from '../Caption';

const DefaultModalContent = ({
  item,
  index,
  boardId,
  showPostMedia,
  formatDistanceLocale,
  customLink,
  copyVisible,
  shareURL,
  linkHandler,
  emailHandler,
  closeModal,
  options,
  embedType,
}) => {
  const handleBuyClick = () => {
    giggAnalytics.logEvent(AnalyticsEvents.CTA_CLICK, {
      boardId,
      boardType: embedType,
      folderId: __gigg.folderId,
      postIndex: index,
      postId: item.id,
      postType: item.service,
      mediaType: getMediaType(item.media),
      isCarousel: item.media?.length > 1,
      CTA_URL: item.customLink.linkUrl,
      scoreWeight: AnalyticsScores.CTA_CLICK,
      firstEvent: {
        _id: window.giggFirstEvent?._id,
        createdDate: window.giggFirstEvent?.createdDate,
      },
    });
  };

  return (
    <>
      <div className={styles['bragify-modal-content']}>
        <div className={styles['bragify-modal-image']}>
          <div
            className={styles['bragify-modal-image-bg']}
            style={{ backgroundImage: `url(${item?.media?.[0]?.large})` }}
          />
          {showPostMedia(item)}
        </div>
        <div className={styles['bragify-modal-info']}>
          <div className={styles['bragify-modal-info-inner']}>
            <div className={styles['bragify-modal-user']}>
              <div>
                <a
                  href={
                    item.service === networks.INSTAGRAM_GRAPH
                      ? item.link
                      : `https://${item.service}.com/${item.username}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.profilePic && <BragifyAvatar src={item.profilePic} />}
                  {item.username && <span className={styles.username}>@{item.username}</span>}
                </a>
              </div>
              {item.service !== networks.CUSTOM && (
                <a
                  href={
                    item.service === networks.INSTAGRAM_GRAPH
                      ? item.link
                      : `https://${item.service}.com/${item.username}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className={[styles['social-icon'], styles[item.service]].join(' ')}>
                    <Icons icon={item.service} />
                  </div>
                </a>
              )}
            </div>
            <div className={styles['bragify-modal-copy']}>
              <Caption
                service={item.service}
                color={options.primaryColor}
                disableLinks={options.disableHashtagLinks}
              >
                {item.caption}
              </Caption>
              <div className={styles['other-info']}>
                {!options.disableDates && item.service !== networks.CUSTOM && (
                  <div className={styles.ts}>
                    {formatDistanceLocale(new Date(item.time || 0), new Date())}{' '}
                    <Trans id="ago">ago</Trans>
                  </div>
                )}
              </div>
            </div>
            {customLink.linkText && customLink.linkUrl && (
              <div className={styles['button-link__container']}>
                <a
                  target="blank"
                  className={styles['button-link']}
                  onClick={handleBuyClick}
                  href={ensureURLProtocol(customLink.linkUrl)}
                >
                  {item.customLink.linkText}
                </a>
              </div>
            )}
            <div className={styles['bragify-modal-footer']}>
              {item.service !== networks.CUSTOM ? (
                <div className={styles.buttons}>
                  <a
                    href={item.link}
                    className={[styles.btn, styles['btn-follow']].join(' ')}
                    style={{ background: options.primaryColor }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.service === networks.OPEN_GRAPH ? (
                      <Trans id="View Link">View Link</Trans>
                    ) : (
                      <Trans id="View Post">View Post</Trans>
                    )}
                  </a>
                </div>
              ) : (
                <div />
              )}
              <ModalShareButtons
                item={item}
                copyVisible={copyVisible}
                shareURL={shareURL}
                linkHandler={linkHandler}
                emailHandler={emailHandler}
                options={options}
                index={index}
                embedType={embedType}
              />
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        aria-label="close dialog"
        aria-labelledby="close-dialog"
        className={styles['bragify-modal-close']}
        onClick={closeModal}
      >
        <FontAwesomeIcon icon={faTimes} aria-label="Close" />
      </button>
    </>
  );
};

export default DefaultModalContent;
